import React, { Component } from 'react';
import InstagramTemplateEditor from "./InstagramTemplateEditor";
import AiImageStudioWorkflowClass from "../modules/common/AiImageStudioWorkflowClass";
import InstagramTutorialReplayPanel from "./tutorial/InstagramTutorialReplayPanel";
import { InstagramTutorialContext } from "./tutorial/InstagramTutorialProvider";
import http from "../modules/api";

const MENU_URL = {
  instagramRegister: "/shop/instagram/InstagramCreatePost",
  instagramAuto: "/shop/instagram/InstagramCreateAiImageAutomation",
  autoSetupStarter: "/shop/instagram/InstagramAutoSetupStarter",
  aiStudioMore: "/shop/instagram/InstagramAiStudio",
  aiTemplateMore: "/shop/instagram/InstagramTemplateList",
};

const AI_STUDIO_APPLY_IMAGE_STORAGE_KEY = "instagram_ai_studio_apply_image";
const AI_STUDIO_APPLY_AUTOMATION_RULE_STORAGE_KEY = "instagram_ai_studio_apply_automation_rule";
const STARTER_APPLY_TEMPLATE_STORAGE_KEY = "instagram_ai_design_starter_apply_template";
const AUTO_SETUP_ANALYSIS_RESULT_STORAGE_KEY = "instagram_auto_setup_analysis_result";


const convertRatioToEditorRatio = (ratio) => {
  return String(ratio || "1/1").replace("/", ":");
};

const studioImageList = [
  {
    sort_no: 1,
    title: "단상 연출",
    src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1767173962676_8314.png",
    input_src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/stablediffusion/input/init_1767173954712_161.png",
    alt: "단상 연출",
    prompt: "생성하고 싶은 배경은 \"연베이지바닥에, 오렌지색벽에 연노란색 동그란 단상 위에 크림이 올려져있고, 나뭇잎그림자가 벽에 살짝 비치는 뷰티사진만들어줘 \" 이야.",
  },
  {
    sort_no: 2,
    title: "몰디브 물방울",
    src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1767173387350_7237.png",
    input_src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/stablediffusion/input/init_1767173378607_9098.png",
    alt: "몰디브 물방울",
    prompt: "생성하고 싶은 배경은 \"몰디브처럼 하늘색 청량하고 맑은 물에 풍덩빠진느낌으로 크림통보다 큰 물방울 , 중간물방울들이 군데군데 퐁퐁 떠있는 뷰티광고사진만들어줘\" 이야.",
  },
  {
    sort_no: 3,
    title: "꽃과 대리석",
    src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1767174360332_6754.png",
    input_src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/stablediffusion/input/init_1767174350602_5381.png",
    alt: "꽃과 대리석",
    prompt: "생성하고 싶은 배경은 \"이 사진과 어울리는 꽃들이 미학적으로 꾸며져있는 대리석 위에 크림통이 있는 뷰티사진만들어줘 \" 이야.",
  },
  {
    sort_no: 4,
    title: "하늘 배경",
    src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1767175399468_2058.png",
    input_src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/stablediffusion/input/init_1767175389299_3562.png",
    alt: "하늘 배경",
    prompt: "생성하고 싶은 배경은 \"모서리가 있고 모서리 끝에 뚜껑없는 크림통이 크림이 오른쪽으로 보이는 방향으로 오른쪽40도 각도로 완전히 기울여져 세워져있고, 크림이 푸딩처럼 촉촉하고 풍성한 크림은 흘러내리지 않고, 이를 왼쪽 밑에서 바라보는 모습으로 배경으로는 구름이 없는 하늘배경의 뷰티사진만들어줘\" 이야.",
  },
  {
    sort_no: 5,
    title: "프리미엄 광고컷",
    src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1767175967470_6912.png",
    input_src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/stablediffusion/input/init_1767175958094_4588.png",
    alt: "프리미엄 광고컷",
    prompt: "생성하고 싶은 배경은 \"이 브랜드와 상품의 특징을 잘 나타낼 수 있는 장소와 소품을 활용하여 전문광고기획사와 포토그래퍼가 2천만원의 비용을 들여 촬영한 것 같은 고퀄리티 광고사진 만들어줘\" 이야.",
  },
  {
    sort_no: 6,
    title: "제품 손 연출",
    src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/genai/output/output_1767176690196_2260.png",
    input_src: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/stablediffusion/input/init_1767176679766_4906.png",
    alt: "제품 손 연출",
    prompt: "생성하고 싶은 배경은 \"이 브랜드와 제품을 돋보이도록 한 손으로 제품을 잡고 배경은 제품을 장점을 잘 살릴 수 있는 배경으로 전문광고기획사와 포토그래퍼가 1천만원의 비용을 들여 촬영한 것 같은 고퀄리티 광고사진 만들어줘\" 이야.",
  },
];

const templateImageList = [
  {
    title: "이벤트/프로모션",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_230330/07107.png",
    event_type_cd: "07107",
    alt: "추천 템플릿 1",
  },
  {
    title: "신상품 런칭",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_230424/07111.png",
    event_type_cd: "07111",
    alt: "추천 템플릿 2",
  },
  {
    title: "리뷰/베스트",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_220914/07000/07079.png",
    event_type_cd: "07079",
    alt: "추천 템플릿 3",
  },
  {
    title: "정보성(카드뉴스)",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_211214/07050.png",
    event_type_cd: "07050",
    alt: "추천 템플릿 4",
  },
  {
    title: "시즌 기획전",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_220714/07073.png",
    event_type_cd: "07073",
    alt: "추천 템플릿 5",
  },
  {
    title: "할인 쿠폰",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_260122/07161.png",
    event_type_cd: "07161",
    alt: "추천 템플릿 6",
  },
];

class InstagramAutoManageHome extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_robo_img_popup: false,
      ai_studio_initial_prompt: "",
      ai_studio_initial_image_url: "",
      show_design_template_popup: false,
      selected_event_seq: "",
      selected_template_event_type_cd: "",
      selected_template_upper_code_cd: "",
      currentRatio: "1/1",
      homeEntryStatus: "CHECKING",
      homeEntryError: "",
    };
    this.homeEntryRequestId = 0;
    this.homeUnmounted = false;
  }

  componentDidMount() {
    this.checkHomeSetupEntry();
  }

  componentWillUnmount() {
    this.homeUnmounted = true;
    this.homeEntryRequestId += 1;
  }

  checkHomeSetupEntry = async () => {
    const requestId = ++this.homeEntryRequestId;
    this.setState({ homeEntryStatus: "CHECKING", homeEntryError: "" });

    try {
      // 기업 분석/최종 저장 여부와 무관하게 사용자별 최초 진입을 DB에서 원자적으로 기록합니다.
      // 요청이 처음 기록된 경우만 true이며, 중복 요청/동시 접속은 false입니다.
      const response = await http.post("/rest/shop/instagram/onboarding/entry");
      if (this.homeUnmounted || requestId !== this.homeEntryRequestId) return;

      const data = response?.data || {};
      if (data.status !== "success" || typeof data.first_entry !== "boolean") {
        throw new Error(data.message || "최초 진입 여부를 확인하지 못했습니다.");
      }

      if (data.first_entry) {
        // 첫 방문 이력은 서버에 기록되었습니다. 튜토리얼 없이 Setup으로 한 번만 이동합니다.
        this.clearAutoSetupAnalysisResult();
        window.location.replace(`${MENU_URL.autoSetupStarter}?step=1`);
        return;
      }

      // 이미 최초 진입한 사용자: 홈 화면을 표시한 다음 튜토리얼 시작 잠금을 해제합니다.
      this.setState({ homeEntryStatus: "READY" }, () => {
        if (!this.homeUnmounted) this.context?.resolveHomeSetupEntry?.();
      });
    } catch (error) {
      if (this.homeUnmounted || requestId !== this.homeEntryRequestId) return;
      console.error("홈 최초 진입 이력 확인 실패", error);
      // 조회 실패를 데이터 0개로 판단하지 않습니다. 튜토리얼도 계속 대기합니다.
      this.setState({
        homeEntryStatus: "ERROR",
        homeEntryError: error.message || "최초 진입 여부를 확인하지 못했습니다.",
      });
    }
  }

  movePage = (url) => {
    window.location.href = url;
  }

  clearAutoSetupAnalysisResult = () => {
    try {
      sessionStorage.removeItem(AUTO_SETUP_ANALYSIS_RESULT_STORAGE_KEY);
    } catch (error) {
      console.warn("자동화 마법사 임시 결과 초기화 실패", error);
    }
  }

  // 수동 실행은 DB 최초 진입 이력을 변경하지 않습니다.
  startAutoSetup = () => {
    this.clearAutoSetupAnalysisResult();
    this.movePage(`${MENU_URL.autoSetupStarter}?step=1`);
  }

  renderImageCard = (item, index) => {
    return (
      <div className="recommend-card recommend-card" key={index}>
        <img src={item.src} alt={item.alt} />
      </div>
    );
  }

  renderImageCardV2 = (item, index) => {
    return (
      <div className="recommend-card recommend-card_v2" key={index}>
        <img src={item.src} alt={item.alt} />
      </div>
    );
  }

  getTemplateRatioByEventTypeCd = (eventTypeCd) => {
    if (String(eventTypeCd || "").startsWith("07")) return "4/5";
    if (String(eventTypeCd || "").startsWith("03")) return "16/9";
    return "1/1";
  }

  getTemplateUpperCodeCdByEventTypeCd = (eventTypeCd) => {
    if (String(eventTypeCd || "").startsWith("07")) return "07000";
    if (String(eventTypeCd || "").startsWith("03")) return "03000";
    return "";
  }

  openTemplateEditor = (item) => {
    const eventTypeCd = item.event_type_cd || "";
    const ratio = this.getTemplateRatioByEventTypeCd(eventTypeCd);

    this.setState({
      show_design_template_popup: true,
      selected_event_seq: "",
      selected_template_event_type_cd: eventTypeCd,
      selected_template_upper_code_cd: this.getTemplateUpperCodeCdByEventTypeCd(eventTypeCd),
      currentRatio: ratio,
    });
  }

    openAiStudioWithPrompt = (item) => {
        this.setState({
            show_robo_img_popup: true,
            ai_studio_initial_prompt: item.prompt || "",
            ai_studio_initial_image_url: item.input_src || "",
        });
    }

    closeAiStudioPopup = () => {
      this.setState({
        show_robo_img_popup: false,
        ai_studio_initial_prompt: "",
        ai_studio_initial_image_url: "",
      });
    }

    handleCloseTemplateEditor = () => {
      this.setState({
        show_design_template_popup: false,
        selected_event_seq: "",
        selected_template_event_type_cd: "",
        selected_template_upper_code_cd: "",
        currentRatio: "1/1",
      });
    }

    moveToCreatePostWithImage = (result) => {
      const imageUrl = result.appliedImage || result.appliedValue || "";

      if (!imageUrl) {
        window.alert("등록할 이미지가 없습니다.");
        return;
      }

      const imageRatio = result.image_ratio || result.ratio || this.props.ratio || "1/1";

      sessionStorage.setItem(AI_STUDIO_APPLY_IMAGE_STORAGE_KEY, JSON.stringify({
        opened_from: "AI_STUDIO_LIST",
        img_url: imageUrl,
        image_url: imageUrl,
        source_url: imageUrl,
        image_ratio: imageRatio,
        ratio: imageRatio,
        ratio_cd: result.ratio_cd || "",
        ai_studio_history_seq: result.ai_studio_history_seq || "",
        selected_final_step_no: result.selectedFinalStepNo || "",
        ai_studio_history_step_seq: result.ai_studio_history_step_seq || "",
        ai_studio_history_step_result_seq: result.ai_studio_history_step_result_seq || "",
        result_no: result.result_no || "",
      }));

      window.location.href = MENU_URL.instagramRegister + "?apply_ai_studio_image=Y";
    }

    moveToAutomationWithRule = (result) => {
      const promptList = result.appliedPrompts || [];

      if (!result.ai_studio_history_seq && (!Array.isArray(promptList) || promptList.length === 0)) {
        window.alert("자동화에 적용할 AI 스튜디오 규칙이 없습니다.");
        return;
      }

      sessionStorage.setItem(AI_STUDIO_APPLY_AUTOMATION_RULE_STORAGE_KEY, JSON.stringify({
        opened_from: "AI_STUDIO_LIST",
        ai_image_rule_applied_yn: "Y",
        ai_image_rule_prompt_list: promptList,
        ai_image_rule_thumb: result.appliedThumb || "",
        ai_studio_history_seq: result.ai_studio_history_seq || "",
        ai_studio_history_title: result.history_title || "",
        history_title: result.history_title || "",
        selected_final_step_no: result.selectedFinalStepNo || "",
        steps: result.steps || [],
        ai_studio_history_step_seq: result.ai_studio_history_step_seq || "",
        ai_studio_history_step_result_seq: result.ai_studio_history_step_result_seq || "",
        result_no: result.result_no || "",
      }));

      window.location.href = MENU_URL.instagramAuto + "?apply_ai_studio_rule=Y";
    }

    handleApplyAiStudio = (result) => {
      this.closeAiStudioPopup();

      if (result.ai_response_type === "IMAGE") {
        this.moveToCreatePostWithImage(result);
      } else {
        this.moveToAutomationWithRule(result);
      }
    }

    applydDesign = (event_seq, img_url, media_source_id, submitInfo) => {
      const applyPayload = {
        opened_from: "AI_DESIGN_STARTER",
        event_seq: event_seq || "",
        img_url: img_url || "",
        media_source_id: media_source_id || "",
        image_ratio: this.state.currentRatio || "1/1",
        event_type_cd: this.state.selected_template_event_type_cd || "",
        upper_code_cd: this.state.selected_template_upper_code_cd || "",
        submit_info: submitInfo || {},
      };

      this.setState({
        show_design_template_popup: false,
        selected_event_seq: "",
        selected_template_event_type_cd: "",
        selected_template_upper_code_cd: "",
        currentRatio: "1/1",
      }, () => {
        sessionStorage.setItem(STARTER_APPLY_TEMPLATE_STORAGE_KEY, JSON.stringify(applyPayload));
        window.location.href = MENU_URL.instagramRegister + "?apply_ai_design_template=Y";
      });
    }

    renderAiStudioPopup = () => {
      if (!this.state.show_robo_img_popup) {
        return null;
      }

      return (
        <AiImageStudioWorkflowClass
          view_mode="popup"
          ai_response_type="IMAGE"
          initial_prompt={this.state.ai_studio_initial_prompt || ""}
          initial_image_url={this.state.ai_studio_initial_image_url || ""}
          onClose={this.closeAiStudioPopup}
          onApplyRule={this.handleApplyAiStudio}
          ratio={this.state.currentRatio || this.props.ratio || "1/1"}
          service_type={this.props.service_type || "01014"}
          opened_from="AI_STUDIO_LIST"
        />
      );
    }

    renderTemplateEditor = () => {
      if (!this.state.show_design_template_popup) {
        return null;
      }

      return (
        <InstagramTemplateEditor
          onClose={this.handleCloseTemplateEditor}
          onSubmit={this.applydDesign}
          event_seq={this.state.selected_event_seq}
          event_type_cd={this.state.selected_template_event_type_cd}
          upper_code_cd={this.state.selected_template_upper_code_cd}
          ratio={convertRatioToEditorRatio(this.state.currentRatio)}
          opened_from="AI_DESIGN_STARTER"
        />
      );
    }

    renderStudioImageCard = (item, index) => {
        return (
            <div
            className="recommend-card"
            key={index}
            onClick={() => this.openAiStudioWithPrompt(item)}
            style={{ cursor: "pointer" }}
            >
            <img src={item.src} alt={item.alt} />
            </div>
        );
    }

    renderTemplateImageCard = (item, index) => {
        const imageUrl = item.imageUrl || item.img_url || item.src || "";

        return (
            <div
            className="recommend-card recommend-card_v2"
            key={index}
            onClick={() => this.openTemplateEditor(item)}
            style={{ cursor: "pointer" }}
            >
            <img src={imageUrl} alt={item.alt} />
            </div>
        );
    }

  render() {
    if (this.state.homeEntryStatus !== "READY") {
      const isChecking = this.state.homeEntryStatus === "CHECKING";
      return (
        <div id="common-page-wrapper" style={{ minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ textAlign: "center", padding: 24 }}>
            {/* <p>{isChecking ? "최초 진입 여부를 확인하고 있습니다." : this.state.homeEntryError}</p> */}
            {!isChecking && (
              <button type="button" onClick={this.checkHomeSetupEntry}>
                다시 시도
              </button>
            )}
          </div>
        </div>
      );
    }

    return (
      <>
        <style>{`
        #instagram-auto-home {
            --color-mint: #00e2e6;
            --color-navy: #0A1A2F;
            --color-gray-text: #6b7280;
            --shadow-card: 0 4px 20px rgba(0,0,0,0.06);
            --shadow-hover: 0 10px 25px rgba(0,226,230,0.15);

            --primary-mint: #00e2e6;
            --primary-mint-hover: #00bfc2;
            --deep-navy: #0A1A2F;
            --deep-navy-hover: #111C3A;

            --radius-md: 12px;
            --radius-sm: 8px;

            // min-height: 100vh;
            padding: 34px 0 36px;
            font-family: 'Noto Sans KR', sans-serif;
            background:
            linear-gradient(
                180deg,
                #dff7ff 0%,
                #ecfbff 220px,
                #f7fdff 420px,
                #ffffff 620px,
                #ffffff 100%
            );
        }

        #instagram-auto-home .main-inner {
            width: 860px;
            max-width: calc(100% - 48px);
            margin: 0 auto;
        }

        #instagram-auto-home .hero {
            text-align: center;
            margin-bottom: 22px;
        }

        #instagram-auto-home .hero-title {
            margin: 0 0 10px;
            font-size: 20px;
            font-weight: 800;
            color: var(--color-navy);
        }

        #instagram-auto-home .hero-desc {
            margin: 0;
            font-size: 14px;
            line-height: 1.6;
            font-weight: 500;
            color: #46606f;
            word-break: keep-all;
        }

        #instagram-auto-home .hero-button-wrap {
            display: flex;
            justify-content: center;
            gap: 14px;
            margin-top: 20px;
        }

        #instagram-auto-home .hero-btn {
            width: 204px;
            height: 50px;
            border-radius: 8px;
            // border: 1px solid #0a0a0a;
            font-size: 17px;
            font-weight: 700;
            cursor: pointer;
            transition: transform 0.18s, box-shadow 0.18s;
            box-shadow: 0 4px 12px rgba(0,0,0,0.08);
        }

        #instagram-auto-home .btn-primary { background: var(--primary-mint); color: var(--deep-navy); }
        #instagram-auto-home .btn-primary:hover { background: var(--primary-mint-hover); color: var(--deep-navy); transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3); }
        #instagram-auto-home .btn-primary:active { background: var(--primary-mint-hover) !important; color: var(--deep-navy) !important; transform: translateY(-1px) !important; box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3) !important; }
        #instagram-auto-home .btn-primary:focus { background: var(--primary-mint-hover) !important; color: var(--deep-navy) !important; transform: translateY(-1px) !important; box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3) !important; }

        #instagram-auto-home .hero-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 18px rgba(0,0,0,0.08);
        }

        #instagram-auto-home .hero-btn.primary:hover {
            color: var(--color-mint);
        }
        #instagram-auto-home .hero-btn.secondary:hover {
            border: 2px solid var(--color-mint);
            background: #f0fdfe !important;
        }

        #instagram-auto-home .hero-btn.primary {
            background: #000;
            color: #fff;
            // border-color: #06485c;
        }

        #instagram-auto-home .hero-btn.secondary {
            background: #fff;
            color: #000;
        }

        #instagram-auto-home .hero-btn.business-plan-btn {
            width: 314px;
            font-size: 15px;
            white-space: nowrap;
        }

        #instagram-auto-home .service-section {
            // background: rgba(255,255,255,0.86);
            padding: 18px 0px 22px;
            margin-bottom: 0;
        }

        /* DisplayHome feature 영역 기준 */
        #instagram-auto-home .section-title {
            font-size: 17px;
            font-weight: 700;
            color: var(--color-navy);
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            gap: 8px;
        }

        #instagram-auto-home .section-title i {
            color: var(--color-mint);
        }

        #instagram-auto-home .grid-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 24px;
        }

        #instagram-auto-home .feature-card {
            background: #fff;
            padding: 16px 18px;
            border-radius: 16px;
            box-shadow: var(--shadow-card);
            border: 1px solid #e5e7eb;
            cursor: pointer;
            transition: all 0.2s;
            display: flex;
            flex-direction: column;
            height: 100%;
        }

        #instagram-auto-home .feature-card:hover {
            transform: translateY(-3px);
            box-shadow: var(--shadow-hover);
            border-color: var(--color-mint);
        }

        #instagram-auto-home .feature-card:hover .feature-title {
            color: var(--color-mint);
        }

        #instagram-auto-home .feature-card:hover .feature-icon-box {
            background-color: #eff6ff;
        }

        #instagram-auto-home .feature-icon-box {
            width: 40px;
            height: 40px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            // margin-bottom: 16px;
            transition: background 0.2s;
        }

        #instagram-auto-home .icon-blue {
            background-color: #eff6ff;
            color: #3b82f6;
        }

        #instagram-auto-home .feature-card:hover .icon-blue {
            background-color: #dbeafe;
        }

        #instagram-auto-home .icon-purple {
            background-color: #faf5ff;
            color: #a855f7;
        }

        #instagram-auto-home .feature-card:hover .icon-purple {
            background-color: #f3e8ff;
        }

        #instagram-auto-home .icon-green {
            background-color: #f0fdf4;
            color: #22c55e;
        }

        #instagram-auto-home .feature-card:hover .icon-green {
            background-color: #dcfce7;
        }

        #instagram-auto-home .feature-header {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-bottom: 16px;
        }

        #instagram-auto-home .feature-title {
            font-size: 16px;
            font-weight: 700;
            color: var(--color-navy);
            transition: color 0.2s;
            margin: 0;
        }

        #instagram-auto-home .feature-desc {
            font-size: 14px;
            color: #6b7280;
            line-height: 1.6;
            // margin-bottom: 24px;
            flex: 1;
            margin-top: 0;
        }

        #instagram-auto-home .recommend-section {
            // background: #fff;
            padding: 0 0 16px;
        }

        #instagram-auto-home .recommend-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 14px 8px 16px;
        }

        #instagram-auto-home .recommend-title {
            margin: 0;
            font-size: 17px;
            font-weight: 700;
            color: #111;
        }

        #instagram-auto-home .more-btn {
            border: none;
            background: transparent;
            font-size: 16px;
            font-weight: 700;
            color: #111;
            cursor: pointer;
        }

        #instagram-auto-home .recommend-grid {
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            gap: 14px;
        }

        #instagram-auto-home .recommend-card {
            width: 100%;
            aspect-ratio: 1 / 1;
            border-radius: 8px;
            overflow: hidden;
            background: #f3f4f6;
            cursor: pointer;
        }
        
        #instagram-auto-home .recommend-card:hover {
            transform: translateY(-3px);
            box-shadow: var(--shadow-hover);
            border: 1px solid var(--color-mint);
        }
        
        #instagram-auto-home .recommend-card_v2 {
            aspect-ratio: 876 / 1174;
        }

        #instagram-auto-home .recommend-card img {
            width: 100%;
            height: 100%;
            display: block;
            object-fit: cover;
        }

        @media (max-width: 800px) {
            #instagram-auto-home {
                padding-bottom: 32px;
            }
            #instagram-auto-home .main-inner {
            max-width: calc(100% - 32px);
            }

            #instagram-auto-home .grid-3 {
            grid-template-columns: 1fr;
            }

            #instagram-auto-home .recommend-grid {
            grid-template-columns: repeat(2, 1fr);
            }

            #instagram-auto-home .hero-button-wrap {
            flex-direction: column;
            align-items: center;
            }

            #instagram-auto-home .hero-desc {
                font-size: 13px;
            }
            #instagram-auto-home .hero-btn {
                max-width: 100%;
            }
        }
        `}</style>


        <div id="common-page-wrapper">
          <main id="instagram-auto-home">
            <div className="main-inner">

              <section className="hero" data-instagram-tutorial="home-intro">
                <h1 className="hero-title">로보MD AI 인스타그램 자동관리</h1>
                <p className="hero-desc">
                  인스타그램에 홍보할 콘텐츠와 홍보글을 로보엠디AI가 작성해드립니다.<br />
                  사진이 없어도 서비스 소개만 적어주시면 AI가 이미지와 문구를 모두 만들어 매일 자동으로 업로드합니다.
                </p>
                <div className="hero-button-wrap">
                  
                </div>
                <div className="hero-button-wrap">
                  <button
                    type="button"
                    className="hero-btn secondary"
                    onClick={() => this.movePage(MENU_URL.instagramRegister)}
                  >
                    콘텐츠 등록
                  </button>

                  <button
                      type="button"
                      className="hero-btn btn-primary"
                      onClick={this.startAutoSetup}
                    >
                      AI 자동화 마법사
                  </button>

                  {/* <button
                    type="button"
                    className="hero-btn primary"
                    onClick={() => this.movePage(MENU_URL.instagramAuto)}
                  >
                    인스타그램 자동화
                  </button> */}

                  {/* <button
                    type="button"
                    className="hero-btn secondary business-plan-btn"
                    onClick={this.startAutoSetup}
                  >
                    사업계획서 기반 콘텐츠 자동화
                  </button> */}
                </div>
              </section>

              <section className="service-section" data-instagram-tutorial="home-service">
                <h3 className="section-title">
                  <i className="fas fa-link"></i>
                  서비스 소개
                </h3>

                <div className="grid-3">
                  <div className="feature-card" onClick={() => {
                    window.location.href = "/shop/instagram/InstagramCopywriterSetting"
                  }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-blue">
                        <i className="fas fa-desktop"></i>
                      </div>
                      <h4 className="feature-title">AI카피라이터</h4>
                    </div>
                    <p className="feature-desc">
                      브랜드성격, 목표, 요구사항과 참고문장을 설정하면 일관성있는 홍보글이 제작됩니다
                    </p>
                  </div>

                  <div className="feature-card" onClick={() => {
                    this.openAiStudioWithPrompt({});
                  }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-purple">
                        <i className="fas fa-layer-group"></i>
                      </div>
                      <h4 className="feature-title">AI활용 디자인</h4>
                    </div>
                    <p className="feature-desc">
                      인스타그램에 활용되는 다양한 템플릿에서 AI 이미지생성 및 디자인 편집할 수 있습니다
                    </p>
                  </div>

                  <div className="feature-card" onClick={() => {
                    window.location.href =
                        MENU_URL.instagramRegister + "?publish_option=SCHEDULED";
                  }}>
                    <div className="feature-header">
                      <div className="feature-icon-box icon-green">
                        <i className="fas fa-truck-fast"></i>
                      </div>
                      <h4 className="feature-title">예약발행</h4>
                    </div>
                    <p className="feature-desc">
                      원하는 시간과 반복일정마다 컨텐츠를 만들거나 자동제작해서 등록할 수 있습니다
                    </p>
                  </div>
                </div>
              </section>

              <section className="recommend-section" data-instagram-tutorial="home-ai-studio">
                <div className="recommend-header">
                  <h3 className="recommend-title">AI 스튜디오 추천 이미지</h3>
                  {/* <button
                    type="button"
                    className="more-btn"
                    onClick={() => this.movePage(MENU_URL.aiStudioMore)}
                  >
                    {"<더보기"}
                  </button> */}
                </div>

                <div className="recommend-grid">
                  {studioImageList.map(this.renderStudioImageCard)}
                </div>
              </section>

              <section className="recommend-section" data-instagram-tutorial="home-ai-design">
                <div className="recommend-header">
                  <h3 className="recommend-title">AI 디자인 추천 템플릿</h3>
                  {/* <button
                    type="button"
                    className="more-btn"
                    onClick={() => this.movePage(MENU_URL.aiTemplateMore)}
                  >
                    {"<더보기"}
                  </button> */}
                </div>

                <div className="recommend-grid">
                    {templateImageList.map(this.renderTemplateImageCard)}
                </div>
              </section>

              <InstagramTutorialReplayPanel />

            </div>
          </main>
        </div>
        {this.renderAiStudioPopup()}
        {this.renderTemplateEditor()}
      </>
    );
  }
}

InstagramAutoManageHome.contextType = InstagramTutorialContext;

export default InstagramAutoManageHome;
